import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';

class ListSettingBtn extends Component {
  constructor(props) {
    super(props);

    this.updateTable = this.updateTable.bind(this);

    //init filter state
    this.state = {
      refTable: null,
      visibleColumns: []
    }

    // set this to ref
    if (props.refs) {
      props.refs(this);
    }
  }

  updateTable() {
    let refTable = (this.props.refTable) ? this.props.refTable : null;
    this.setState({
      refTable: refTable
    });
  }

  initVisibleColumns = () => {
    const { visibleColumnsConfig, defaultColumns } = this.props;
    let newVisibleColumns = [];
    if (defaultColumns && defaultColumns.length > 0) {      
      visibleColumnsConfig.columns.forEach(visibleColumn => {
        defaultColumns.forEach(defaultColumn => {
          if (visibleColumn.field === defaultColumn.field) {
            if (defaultColumn.hasOwnProperty("visible")) {
              let visible = defaultColumn.visible;
              if (visible) {
                visibleColumn.checked = true;
              } else {
                visibleColumn.checked = false;
              }
            } else {
              visibleColumn.checked = true;
            }
            newVisibleColumns.push(visibleColumn);
          }
        });        
      });  
      this.setState({
        visibleColumns:newVisibleColumns 
      })
    }
  }

  renderVisibleColumns = (tableId) => {
    const { visibleColumnsConfig } = this.props;
    if (visibleColumnsConfig) {
      const filterOptions = this.renderVisibleColumnOptions(tableId);
      return (
        <div className='area-visible-columns'>
          <div className='dropdown-tip'>{visibleColumnsConfig.title}</div>
          { filterOptions }
        </div>
      );
    } else {
      return (
        <div className='no-quick-filters'></div>
      );
    }    
  }

  renderVisibleColumnOptions = (tableId) => {
    const { visibleColumns } = this.state;
    return visibleColumns.map((item, index) => {
      let dropdownClass = 'select-item';
      if (item.visible === false) {
        dropdownClass = 'no-display';
      }

      let classChecked = 'icon-btn-checkbox-n';
      if (item.checked) {
        classChecked = 'icon-btn-checkbox-p';
      }

      return (
        <Dropdown.Item key={index} onClick={(e) => this.selectVisibleColumnItem(e, item)} className={dropdownClass}>
          <span className='check-icon-area'>
            <span id={tableId + '-' + item.name + '-' + item.field} className={classChecked}/>
          </span>
          <span className='check-text'>{item.title}</span>
        </Dropdown.Item>
      );
    });
  } 

  selectVisibleColumnItem = (e, item) => {    
    const { tableId, refTable, defaultColumns } = this.props;
    let { visibleColumns } = this.state;

    // checked the Dropdown Menu Option
    let elChecked = document.getElementById(tableId + '-' + item.name + '-' + item.field);
    let classTarget = elChecked.className;
    const doCheck = classTarget === 'icon-btn-checkbox-n';
    const classCheck = doCheck ? 'icon-btn-checkbox-p' : 'icon-btn-checkbox-n';
    elChecked.className = classCheck;

    // fix visibleColumns value
    visibleColumns.forEach(visibleColumn => {
      if (visibleColumn.name === item.name) {
        visibleColumn.checked = doCheck;
      }
    });

    // combine the columns with visible
    let newColumns = [];    
    defaultColumns.forEach(defaultColumn => {
      if (defaultColumn.title) {
        visibleColumns.forEach(visibleColumn => {        
          if (visibleColumn.field === defaultColumn.field) {
            let newColumn = defaultColumn;
            newColumn.visible = visibleColumn.checked;
            newColumns.push(newColumn);
          }
        });
      } else {
        // it's button columns, always display
        newColumns.push(defaultColumn);
      }
    });
    
    if (refTable) {
      refTable.setColumns(newColumns);
    }    

    this.setState({
      visibleColumns: visibleColumns
    });
  }

  componentDidMount() {
    // if call render will do this method
    this.updateTable();

    this.initVisibleColumns();
  }  

  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.refTable !== this.props.refTable) {
      this.updateTable();
    }
  }

  render() {
    const { tableId } = this.props;
    const renderVisibleColumnsOption = this.renderVisibleColumns(tableId);

    return (
      <span className='adjust-visible-columns-area' title='visible columns'>
        <Dropdown>
          <Dropdown.Toggle id={tableId + "ListSettingBtn"} variant="success" className='dropdown-toggle'>&nbsp;</Dropdown.Toggle>
          <Dropdown.Menu id={tableId + "ListSettingMenu"} flip={true}>
          { renderVisibleColumnsOption }
          </Dropdown.Menu>
        </Dropdown>
      </span>
    )
  }
}

export default ListSettingBtn;